export default __webpack_public_path__ + "static/media/The_Nest_large_2.3f96933a.jpg";